import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
	component: HomePage,
});

function HomePage() {
	useEffect(() => {
		window.location.href = "/connexion";
	}, []);

	return null;
}
